/**
 * Detects if the current environment is staging or production
 * and provides the appropriate redirect URLs
 */

export type Environment = 'staging' | 'production';

function isPrivateLanHost(hostname: string) {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
  );
}

/**
 * Determines the current environment based on the hostname
 */
export function getEnvironment(): Environment {
  const origin = window.location.origin;
  const hostname = window.location.hostname;

  if (
    origin.includes('play-dev.macintosh-ix88.thinkflagship.com') ||
    origin.includes('localhost:3001') ||
    isPrivateLanHost(hostname)
  ) {
    return 'staging';
  }

  return 'production';
}